import React from "react";

import { Container } from "./styles";

function InputCheckbox({
  id,
  label,
  value,
  isChecked,
  mensagemErro,
  handler,
  required,
  ...rest
}) {
  return (
    <Container>
      <article>
        <input
          key={id}
          id={value}
          // name={id}
          {...rest}
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={handler}
        />
        {/* <label>{label}</label> */}
        <label htmlFor={value}>{label}</label>
      </article>
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default InputCheckbox;
